import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../context/AuthContext'; // Import the auth store

interface PrivateRouteProps {
  // You can add roles prop here later if you want role-based access control
  // allowedRoles?: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  // const userRoles = useAuthStore((state) => state.user?.roles || []); // For role-based access

  if (!isAuthenticated) {
    // User not authenticated, redirect to login page
    return <Navigate to="/login" replace />;
  }

  // Optional: Role-based access control
  // if (allowedRoles && allowedRoles.length > 0) {
  //   const hasRequiredRole = allowedRoles.some(role => userRoles.includes(role));
  //   if (!hasRequiredRole) {
  //     // User authenticated but doesn't have required role, redirect to unauthorized page or dashboard
  //     return <Navigate to="/" replace />; // Or /unauthorized
  //   }
  // }

  // User is authenticated and has required roles (if any), render child routes
  return <Outlet />;
};

export default PrivateRoute;